var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-course-layout',{attrs:{"title":"ویرایش دوره","submitFunction":_vm.UpdateCourse}})
}
var staticRenderFns = []

export { render, staticRenderFns }